




















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { CreatorService } from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { formatMoneyString } from "@/lib/moneyHelpers";
import ImagePreview from "@/components/ImagePreview";
import CreatorServiceTag from "@/features/CreatorService/components/CreatorServiceTag.vue";
import { CreatorServiceCategoryNamesMap } from "@/features/CreatorService/const";
import { resolveCreatorTagsByIds } from "@/features/CreatorService/helpers";

export default defineComponent({
  name: "CreatorServiceItem",
  components: { CreatorServiceTag, ImagePreview },
  props: {
    item: { type: Object as PropType<CreatorService>, required: true },
  },
  setup(props) {
    const previewSrc = computed(() =>
      props.item.preview ? MediaFilesController.getImageThumbnail(props.item.preview.urlPart, "1080p") : null
    );

    const categoryLabel = computed(() => {
      return CreatorServiceCategoryNamesMap[props.item.category] || props.item.category;
    });

    const formattedPrice = computed(() => {
      return formatMoneyString(props.item.price);
    });

    const resolvedTags = computed(() => resolveCreatorTagsByIds(props.item.tags || []));

    return {
      previewSrc,
      categoryLabel,
      formattedPrice,
      resolvedTags,
    };
  },
});
